export const hasMultiBlocks = state => state.blocks.size > 1
export const hasLinks = state => state.inlines.some(inline => inline.type === 'link')

export const insertPlaceHolderFile = ({ state }) => {
  return state
    .transform()
    .insertInline({
      type: 'PlaceHolderFile',
      data: {isPlaceHolder: true},
      isVoid: true
    })
    .apply()
}

export const removePlaceHolderFile = ({ state }) => {
  return state
    .transform()
    .deleteBackward(1)
    .apply()
}

export const insertInlineFile = ({ state, data }) => {
  data.target = '_blank'
  data.openModal = false
  const link = {
    type: 'link',
    data
  }

  const startOffset = state.selection.startOffset
  let transform = state.transform()

  if (state.isCollapsed && !hasMultiBlocks(state)) {
    let anchorText = data.text || data.title || data.href
    transform
      .insertText(`${anchorText}`)
      .moveOffsetsTo(startOffset, startOffset + anchorText.length)
      .wrapInline(link)
  }

  transform
      .focus()
  return transform.apply()
}



// WEBPACK FOOTER //
// ./src/components/FileSlatePlugin/FileUtils.js